import { render, staticRenderFns } from "./setting-exam.vue?vue&type=template&id=aaa2892e&"
import script from "./setting-exam.vue?vue&type=script&lang=js&"
export * from "./setting-exam.vue?vue&type=script&lang=js&"
import style0 from "./setting-exam.vue?vue&type=style&index=0&id=aaa2892e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports